import { type FC, type ReactNode } from "react";
import PropTypes from "prop-types";

import { withAuthGuard } from "src/hocs/with-auth-guard";
import { useSettings } from "src/hooks/use-settings";

import { HorizontalLayout } from "./horizontal-layout";
import { VerticalLayout } from "./vertical-layout";
import { UserDataContext, UserDataProvider, UserDataContexType } from "src/contexts/userData-context";
import { HouseholdProvider } from "src/contexts/household-context";

interface LayoutProps {
  children?: ReactNode;
}

export const Layout: FC<LayoutProps> = withAuthGuard((props) => {
  const settings = useSettings();

  return (
    <UserDataProvider>
      <UserDataContext.Consumer>
        {(userDataContext: UserDataContexType) => {
          return (
            <HouseholdProvider userData={userDataContext.userData || null} ownerUserData={userDataContext.ownerUserData || null} updateProHouseholdContext={userDataContext.updateProHouseholdContext || null}  >
              {settings.layout === "horizontal" ? (
                <HorizontalLayout
                  navColor={settings.navColor}
                  {...props}
                />
              ) : (
                <VerticalLayout
                  navColor={settings.navColor}
                  {...props}
                />
              )}
            </HouseholdProvider>
          );
        }}
      </UserDataContext.Consumer>
    </UserDataProvider>
  );
});

Layout.propTypes = {
  children: PropTypes.node as PropTypes.Validator<ReactNode>,
};
